import { ServiceType } from '@core/services/models/service.interface';

export function getLabel(type: ServiceType): string {
    switch (type) {
        case ServiceType.SKAPIEC:
            return 'Skąpiec.pl';
        case ServiceType.RETAIL_MEDIA:
            return 'Retail Media Network';
        case ServiceType.LAMODA:
            return 'Lamoda.pl';
        case ServiceType.OPINEO:
            return 'Opineo.pl';
        case ServiceType.VIDEO_ADS:
            return 'Reklama wideo';
        case ServiceType.PERFORMANCE_EASY:
            return 'Seller';
        case ServiceType.MAILING:
            return 'Mailing';
        case ServiceType.MAILING_INBOX:
            return 'Poczta Inbox';
        case ServiceType.MAILING_RETARGETING:
            return 'Mailing e-commerce';
        case ServiceType.RETAIL_MEDIA_PARTNER:
            return 'Retail Media Network';
    }

    return 'Nieznana usługa';
}

export function getLogo(type: ServiceType): string {
    switch (type) {
        case ServiceType.SKAPIEC:
            return 'assets/protected/images/services/main-logo/skapiec.svg';
        case ServiceType.RETAIL_MEDIA:
            return 'assets/protected/images/services/main-logo/rmn.svg';
        case ServiceType.LAMODA:
            return 'assets/protected/images/services/main-logo/lamoda.svg';
        case ServiceType.OPINEO:
            return 'assets/protected/images/services/main-logo/opineo.svg';
        case ServiceType.VIDEO_ADS:
            return 'assets/protected/images/services/main-logo/video.svg';
        case ServiceType.PERFORMANCE_EASY:
            return 'assets/protected/images/services/main-logo/seller.svg';
        case ServiceType.MAILING:
            return 'assets/protected/images/services/main-logo/mailing.svg';
        case ServiceType.MAILING_INBOX:
            return 'assets/protected/images/services/main-logo/mailing-inbox.svg';
        case ServiceType.MAILING_RETARGETING:
            return 'assets/protected/images/services/main-logo/mailing-retargeting.svg';
        default:
            return 'assets/protected/images/no_image.svg';
    }
}

export function hasPaymentsEnabled(type: ServiceType): boolean {
    return [
        ServiceType.PERFORMANCE_EASY,
        ServiceType.MAILING,
        ServiceType.MAILING_INBOX
    ].includes(type);
}
